module.exports = __webpack_public_path__ + "img/logo.50959656.png";